<template>
  <v-container>
    <vue-cal
      class="vuecal--green-theme vuecal__mt"
      :class="{ table__disabled: loading }"
      ref="vuecal1"
      :locale="$i18n.locale"
      :time-cell-height="timeCellHeight"
      :active-view="selectedView1"
      :selected-date="selectedDate1"
      :time-from="timeFrom"
      :time-to="24 * 60"
      :time-step="15"
      active-view="day"
      :disable-views="['years', 'year', 'week']"
      hideViewSelector
      :events="events"
      :split-days="playgrounds"
      :sticky-split-labels="stickySplitLabels"
      clickToNavigate
      watchRealTime
      :on-event-click="onEventClick"
      @cell-focus="selectedDate2 = $event"
      @view-change="debounceChangeCal($event)"
    >
      <template #event="{ event, view }">
        <div style="font-size: 12px">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              padding: 2px;
            "
          >
            <div>
              <strong
                >{{ moment.parseZone(event.start).format("HH:mm") }}-</strong
              >
              <strong>{{ moment.parseZone(event.end).format("HH:mm") }}</strong>
            </div>
            <div
              @click.stop="openDialogForm"
              v-if="event.available_persons > 0"
              id="book_btn"
            >
              <strong
                v-if="
                  event.pricing.session_price > 1 ||
                  event.pricing.personal_price
                "
                v-html="convertPriceType(event)"
              >
              </strong>
              <span
                v-if="event.pricing.personal_price"
                style="margin-left: -4px; white-space: nowrap"
              >
                <v-icon>mdi-plus-thick</v-icon>
                <v-icon small style="margin-top: 2px; margin-left: -8px"
                  >mdi-account</v-icon
                >
              </span>
              <v-icon v-else>mdi-plus-thick</v-icon>
            </div>
          </div>

          <div @click.stop="openDialogOrder">
            <div
              :class="[
                { 'purple lighten-3': event.content.order_type === 4 },
                { 'blue lighten-3': event.content.order_type === 3 },
                { 'red lighten-3': event.content.paid == 0.0 },
                {
                  'orange lighten-3':
                    event.content.need_paid > 0 && event.content.paid != 0,
                },
                {
                  'green lighten-3':
                    event.content.status === 6 && event.content.order_type != 3,
                },
              ]"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: baseline;
                  padding-right: 5px;
                "
              >
                <div>
                  <v-icon dense v-if="event.id !== ' '">mdi-identifier</v-icon>
                  <span v-html="event.id" style="margin-top: 5px" />
                </div>
                <div>
                  <v-icon dense v-if="event.persons !== ' '"
                    >mdi-account-multiple</v-icon
                  >
                  <span v-html="event.persons" />
                </div>
              </div>
              <span v-html="event.name" />
            </div>

            <div
              class="purple--text pl-1"
              v-if="event.content.order_type === 4"
              v-html="$t('BAFormEvent')"
            />
            <div
              class="blue--text pl-1"
              v-if="event.content.order_type === 3"
              v-html="$t('BAItemFree')"
            />
            <div
              class="blue--text pl-1"
              v-else-if="event.content.order_type === 2"
              v-html="$t('BAItemTech')"
            />
            <div
              class="green--text pl-1"
              v-else-if="event.content.status === 6"
              v-html="$t('BAItemPayed') + convertPrice(event.content.paid)"
            />
            <div
              class="red--text pl-1"
              v-else-if="event.content.paid == 0.0"
              v-html="
                $t('BAItemNotPayed') + convertPrice(event.content.need_paid)
              "
            />
            <div
              class="red--text pl-1"
              v-else-if="event.content.status === 4"
              v-html="$t('BAItemCancelled')"
            />
            <div
              class="orange--text pl-1"
              v-else-if="event.content.need_paid > 0"
              v-html="
                $t('BAItemToPay') +
                ' ' +
                convertPrice(event.content.purchase - event.content.paid)
              "
            />
            <div
              class="red--text pl-1"
              v-else-if="event.content.need_paid < 0"
              v-html="
                $t('BAItemOverPay') +
                ' ' +
                convertPrice(event.content.purchase - event.content.paid)
              "
            />
            <span
              v-if="event.orders.length > 1"
              v-html="' ' + $t('moreOrders') + ' ' + (event.orders.length - 1)"
            />
          </div>
        </div>
      </template>

      <template #time-cell="{ hours, minutes }">
        <div :class="{ 'vuecal__time-cell-line': true, hours: !minutes }">
          <strong v-if="!minutes" style="font-size: 15px">{{ hours }}</strong>
          <span v-else style="font-size: 11px">{{ minutes }}</span>
        </div>
      </template>
    </vue-cal>

    <vue-cal
      v-if="selectedView2 === 'day'"
      class="vuecal--green-theme"
      :class="{ table__disabled: loading }"
      hideViewSelector
      hideTitleBar
      ref="vuecal2"
      :time-cell-height="timeCellHeight"
      :active-view="selectedView2"
      :selected-date="selectedDate2"
      :time-from="0 * 60"
      :time-to="timeTo"
      :time-step="15"
      active-view="day"
      :disable-views="['years', 'year', 'week', 'month']"
      :events="events2"
      :split-days="playgrounds2"
      clickToNavigate
      watchRealTime
      :on-event-click="onEventClick"
    >
      <template #event="{ event, view }">
        <div style="font-size: 12px">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              padding: 2px;
            "
          >
            <div>
              <strong
                >{{ moment.parseZone(event.start).format("HH:mm") }}-</strong
              >
              <strong>{{ moment.parseZone(event.end).format("HH:mm") }}</strong>
            </div>
            <div
              @click.stop="openDialogForm"
              v-if="event.available_persons > 0"
              id="book_btn"
            >
              <strong
                v-if="
                  event.pricing.session_price > 1 ||
                  event.pricing.personal_price
                "
                v-html="convertPriceType(event)"
              >
              </strong>
              <span
                v-if="event.pricing.personal_price"
                style="margin-left: -4px; white-space: nowrap"
              >
                <v-icon>mdi-plus-thick</v-icon>
                <v-icon small style="margin-top: 2px; margin-left: -8px"
                  >mdi-account</v-icon
                >
              </span>
              <v-icon v-else>mdi-plus-thick</v-icon>
            </div>
          </div>

          <div @click.stop="openDialogOrder">
            <div
              :class="[
                { 'purple lighten-3': event.content.order_type === 4 },
                { 'blue lighten-3': event.content.order_type === 3 },
                { 'red lighten-3': event.content.paid == 0.0 },
                {
                  'orange lighten-3':
                    event.content.need_paid > 0 && event.content.paid != 0,
                },
                {
                  'green lighten-3':
                    event.content.status === 6 && event.content.order_type != 3,
                },
              ]"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: baseline;
                  padding-right: 5px;
                "
              >
                <div>
                  <v-icon dense v-if="event.id !== ' '">mdi-identifier</v-icon>
                  <span v-html="event.id" />
                </div>
                <div>
                  <v-icon dense v-if="event.persons !== ' '"
                    >mdi-account-multiple</v-icon
                  >
                  <span v-html="event.persons" />
                </div>
              </div>
              <span v-html="event.name" />
            </div>

            <div
              class="purple--text pl-1"
              v-if="event.content.order_type === 4"
              v-html="$t('BAFormEvent')"
            />
            <div
              class="blue--text pl-1"
              v-if="event.content.order_type === 3"
              v-html="$t('BAItemFree')"
            />
            <div
              class="blue--text pl-1"
              v-else-if="event.content.order_type === 2"
              v-html="$t('BAItemTech')"
            />
            <div
              class="green--text pl-1"
              v-else-if="event.content.status === 6"
              v-html="$t('BAItemPayed') + convertPrice(event.content.paid)"
            />
            <div
              class="red--text pl-1"
              v-else-if="event.content.paid == 0.0"
              v-html="
                $t('BAItemNotPayed') + convertPrice(event.content.need_paid)
              "
            />
            <div
              class="red--text pl-1"
              v-else-if="event.content.status === 4"
              v-html="$t('BAItemCancelled')"
            />
            <div
              class="orange--text pl-1"
              v-else-if="event.content.need_paid > 0"
              v-html="
                $t('BAItemToPay') +
                ' ' +
                convertPrice(event.content.purchase - event.content.paid)
              "
            />
            <div
              class="red--text pl-1"
              v-else-if="event.content.need_paid < 0"
              v-html="
                $t('BAItemOverPay') +
                ' ' +
                convertPrice(event.content.purchase - event.content.paid)
              "
            />
            <span
              v-if="event.orders.length > 1"
              v-html="' ' + $t('moreOrders') + ' ' + (event.orders.length - 1)"
            />
          </div>
        </div>
      </template>

      <template #time-cell="{ hours, minutes }">
        <div :class="{ 'vuecal__time-cell-line': true, hours: !minutes }">
          <strong v-if="!minutes" style="font-size: 15px">{{ hours }}</strong>
          <span v-else style="font-size: 11px">{{ minutes }}</span>
        </div>
      </template>
    </vue-cal>
  </v-container>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import { mapGetters } from "vuex";

export default {
  components: {
    VueCal,
  },
  props: [
    "timeFrom",
    "timeTo",
    "events",
    "events2",
    "selectedDate1",
    "selectedDate2",
    "selectedView1",
    "selectedView2",
    "loading",
  ],

  data() {
    return {
      timeCellHeight: 105,
      stickySplitLabels: true,
    };
  },
  computed: {
    ...mapGetters(["location"]),
    playgrounds() {
      return this.location.playgrounds
        .filter((e) => {
          return (
            e.types === "the_cube" ||
            e.types === "arena" ||
            e.types === "lounge"
          );
        })
        .map((playground) => {
          return {
            id: playground.id,
            label: playground.name,
          };
        });
    },
    playgrounds2() {
      return this.location.playgrounds
        .filter((e) => {
          return (
            e.types === "the_cube" ||
            e.types === "arena" ||
            e.types === "lounge"
          );
        })
        .map((playground) => {
          return {
            id: playground.id,
            label: " ",
          };
        });
    },
  },
  methods: {
    onEventClick(e) {
      this.$emit("on-event-click", e);
    },
    debounceChangeCal($event) {
      this.$emit("debounce-change-cal", $event);
    },
    openDialogForm() {
      this.$emit("open-dialog-form");
    },
    openDialogOrder() {
      this.$emit("open-dialog-order");
    },
    convertPrice(value) {
      let currency = this.location.currency;
      let price = parseFloat(value);

      if (currency.is_before) {
        return currency.code + currency.blank_place + price;
      } else {
        return price + currency.blank_place + currency.code;
      }
    },
    convertPriceType(event) {
      if (event.pricing.session_price) {
        return " " + this.convertPrice(event.pricing.session_price);
      } else if (event.pricing.session_price && event.pricing.personal_price) {
        return " " + this.convertPrice(event.pricing.personal_price);
      } else {
        return " " + this.convertPrice(event.pricing.personal_price) + `/`;
      }
    },
  },
};
</script>

<style>
.vuecal__header {
  position: fixed;
  top: 158px;
  z-index: 2;
  width: 93%;
  max-width: 1661px;
  background-color: #42b983;
}

.vuecal__body {
  background-color: rgba(226, 242, 253, 0.7);
}

.vuecal__no-event {
  display: none;
}

.vuecal__event {
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.vuecal__time-cell-line.hours:before {
  border-color: #42b983;
}

.vuecal--month-view .vuecal__cell {
  height: 80px;
}

.v-card--hover:hover {
  cursor: wait;
}

.vuecal__cell--selected {
  z-index: 0;
}

.vuecal__mt .vuecal__body {
  margin-top: 187px;
}

.v-input .v-input__control .v-input__slot {
  margin-bottom: 0;
}

.vuecal__now-line {
  border-top: 5px solid red;
}

.table__disabled {
  opacity: 0.7;
  cursor: default;
}

@media (max-width: 1750px) {
  .vuecal__header {
    width: 92.7%;
  }
}

@media (max-width: 1650px) {
  .vuecal__header {
    width: 92.3%;
  }
}

@media (max-width: 1550px) {
  .vuecal__header {
    width: 91.9%;
  }
}

@media (max-width: 1450px) {
  .vuecal__header {
    width: 91.3%;
  }
}

@media (max-width: 1400px) {
  .vuecal__header {
    width: 91%;
  }
}

@media (max-width: 1300px) {
  .vuecal__header {
    width: 90%;
  }
}

@media (max-width: 1250px) {
  .vuecal__header {
    width: 89.7%;
  }
}
</style>
